<template>
  <br/>
  <div class="row">
    <div class="col-lg-3 col-md-6 col-sm-12 mb-3">
      <label for="search" class="form-label me-2 mt-2">Search</label>
      <input id="search" class="form-control" placeholder="Name, slug, email or description" v-model="keyword" @input="searchKeyword"/>
    </div>
    <div class="col-lg-3 col-md-6 col-sm-12 mb-3">
      <label for="per-page" class="form-label me-2 mt-2">Per page</label>
      <select id="per-page" class="form-control" v-model="perPage" @change="perPageFilter(perPage)">
        <option :value="10">10</option>
        <option :value="20">20</option>
        <option :value="50">50</option>
      </select>
    </div>
    <div class="col-lg-3 col-md-6 col-sm-12 mb-3">
      <label for="country" class="form-label me-2 mt-2">Country</label>
      <select id="country" class="form-control" v-model="selectedCountry" @change="changeCountry(selectedCountry)">
        <option value="">All</option>
        <option v-for="country in countries" :key="country.value" :value="country.value">{{ country.label }}</option>
      </select>
    </div>
    <div class="col-lg-3 col-md-6 col-sm-12 mb-3">
      <label for=" type" class="form-label me-2 mt-2">Type</label>
      <select id=" type" class="form-control" v-model="type" @change="changeType(type)">
        <option value="">All</option>
        <option value="1">Country</option>
        <option value="2">Personal</option>
        <option value="3">Default</option>
      </select>
    </div>
  </div>

  <div class="d-flex justify-content-end mb-3">
    <div >
      <router-link
          :to="{ name: 'CreateFeeRule' }"
          class="btn btn-success form-control"
          aria-label="Add new partner"
      >
        <span>Add fee</span>
      </router-link>
    </div>
  </div>



  <div class="table-responsive">
    <div class="alert alert-success" role="alert" v-if="success">
      {{ success}}
    </div>
    <div class="alert alert-danger" role="alert" v-if="errorConfirm">
      {{ errorConfirm}}
    </div>
    <table class="table">
      <thead>
        <tr>
          <th scope="col"># ID</th>
          <th scope="col">Creator name, slug</th>
          <th scope="col">Country</th>
          <th scope="col">Currency</th>
          <th scope="col">Type</th>
          <th scope="col">Valid</th>
          <th scope="col" style="width: 162px;">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="loading">
          <td colspan="7" class="text-center"><font-awesome-icon icon="fa-solid fa-sync" spin/></td>
        </tr>
        <tr v-else-if="channels.length > 0" v-for="channel in channels">
          <th scope="row">{{channel.id}}</th>
          <td>
            <p>{{channel.name}}</p>
            <a :href="channel.link">{{channel.slug}}</a>
          </td>
          <td>{{ getCountryName(channel.country_code) }}</td>
          <td>{{ channel.currency || "Any" }}</td>
          <td>
            <span v-if="channel.type === 1" class="badge badge-info">
              Country
            </span>
            <span v-else-if="channel.type === 2" class="badge badge-success">
              Personal
            </span>
            <span v-else-if="channel.type === 3" class="badge badge-warning">
              Default
            </span>
          </td>
          <td>
            <span v-if="channel.valid_from || channel.valid_until || channel.type === 3">{{ formatValidity(channel.valid_from, channel.valid_until) }}</span>
          </td>
          <td>
            <div class="btn-group-sm d-flex gap-3" role="group">
              <router-link :to="{name: 'UpdateFeeRule', params: {id: channel.id}}" class="btn btn-warning">Edit</router-link>
              <button @click="deleteTax(channel.id, channel.name)" class="btn btn-danger">Delete</button>

            </div>
          </td>
        </tr>
        <tr v-else>
          <td colspan="7" class="text-center">No fees</td>
        </tr>
      </tbody>
    </table>
    <div class="d-flex justify-content-between" v-if="totalRecords >= 1">
      <div>
        <div class="p-2">
          <p>Total creators: {{ totalRecords }}</p>
        </div>
      </div>
      <div>
        <div class="p-2">
          <nav v-if="totalPages >= 1" aria-label="Page navigation example">
            <ul class="pagination">
              <li class="page-item" :class="{disabled: currentPage - 1 < 1}">
                <a @click="paginate(currentPage - 1)" class="page-link">Previous</a>
              </li>
              <li class="page-item" :class="{active: 1 === currentPage}">
                <a @click="paginate(1)" class="page-link" :class="{'not-clickable': currentPage === 1}">1</a>
              </li>
              <li class="page-item" v-if="currentPage - 2 > 1">
                <a href="#" class="page-link">...</a>
              </li>
              <li class="page-item" v-if="currentPage - 2 > 1">
                <a @click="paginate(currentPage - 2)" class="page-link">{{ currentPage - 2}}</a>
              </li>
              <li class="page-item" v-if="currentPage - 1 > 1">
                <a @click="paginate(currentPage - 1)" class="page-link">{{ currentPage - 1}}</a>
              </li>
              <li class="page-item" v-if="currentPage !== 1"  :class="{active: currentPage}">
                <a @click="paginate(currentPage)" class="page-link" :class="{'not-clickable': currentPage}">{{currentPage }}</a>
              </li>
              <li class="page-item" v-if="currentPage + 1 <= totalPages">
                <a @click="paginate(currentPage + 1)" class="page-link">{{ currentPage + 1}}</a>
              </li>
              <li class="page-item" v-if="currentPage + 2 <= totalPages">
                <a @click="paginate(currentPage + 2)" class="page-link">{{ currentPage + 2}}</a>
              </li>
              <li class="page-item" v-if="currentPage + 2 < totalPages">
                <a href="#" class="page-link">...</a>
              </li>
              <li class="page-item" v-if="currentPage !== totalPages && currentPage + 2 < totalPages" :class="{active: totalPages === currentPage}">
                <a @click="paginate(totalPages)" class="page-link" :class="{'not-clickable': totalPages === currentPage}">{{totalPages }}</a>
              </li>
              <li class="page-item" :class="{disabled: currentPage + 1 > totalPages}">
                <a @click="paginate(currentPage + 1)" class="page-link">Next</a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import axios from 'axios';
import _debounce from "lodash/debounce";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      loading: true,
      disableExport: false,
      channels: [],
      countries: [],
      errorConfirm: '',
      selectedCountry: '',
      type: '',
      contentCategories: [],
      success: '',
      keyword: '',
      currentPage: 1,
      totalPages: 0,
      totalRecords: 0,
      perPage: 20,
      disableConfirm: false,
      disableDeny: false
    }
  },

  mounted() {
    this.getCountries();
    this.getTaxes(1, 20, '',   '', '');
  },

  methods: {
    formatValidity(from, until) {
      const day = (value) => (value ? String(value).slice(0, 10) : null);
      return `${day(from) ?? 'always'} → ${day(until) ?? 'open-ended'}`;
    },

    getCountries() {
      this.loading = true;
      axios.get(`/admin/countries`).then(response => {
        this.countries = Array.isArray(response.data) ? response.data : [];
        this.loading = false;
      })
          .catch(error => {
            this.loading = false;
            console.log(error);
          });
    },
    debounceGetTaxes: _debounce(function (page, perPage, country, type, keyword) {
      this.loading = true;
      axios.get(`/admin/fee-rules?page=${page}&per_page=${perPage}&country_code=${country}&type=${type}&name=${encodeURIComponent(keyword)}`)
          .then(response => {
            this.channels = response.data.data;
            this.totalPages = response.data.last_page;
            this.totalRecords = response.data.total;
            this.loading = false;
          })
          .catch(error => {
            this.loading = false;
            console.log(error);
          });
    }, 500),


    getTaxes(page, perPage, country,  type, keyword) {
      this.loading = true;
      this.debounceGetTaxes(page, perPage, country, type, keyword);
    },

    changeCountry(country) {
      this.selectedCountry = country;
      this.getTaxes(this.currentPage, this.perPage, this.selectedCountry, this.type, this.keyword);
    },

     changeType( type) {
      this.type =  type;
      this.getTaxes(this.currentPage, this.perPage, this.selectedCountry, this.type, this.keyword);
    },

    searchKeyword() {
      this.getTaxes(this.currentPage, this.perPage, this.selectedCountry, this.type, this.keyword);
    },

    perPageFilter(perPage) {
      this.perPage = perPage;
      this.getTaxes(this.currentPage, this.perPage, this.selectedCountry, this.type,  this.keyword);
    },

    paginate(page) {
      this.currentPage = page;
      this.getTaxes(this.currentPage, this.perPage, this.selectedCountry, this.type, this.keyword);
    },

    getCountryName(countryCode) {
      if (!countryCode) {
        return '';
      }

      if (typeof countryCode === 'object' && countryCode !== null) {
        return countryCode.label || countryCode.name || '';
      }

      // Если country_code - это строка (старая структура данных)
      if (!this.countries || !Array.isArray(this.countries)) {
        return '';
      }

      const country = this.countries.find(c => {
        if (!c) return false;
        return c.value && c.value === countryCode;
      });
      return country ? country.label : '';
    },

    async deleteTax(id, name) {
      const confirmed = await Swal.fire({
        title: 'Confirm Deletion',
        text: `Are you sure you want to delete the fee "${name}"?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete',
        cancelButtonText: 'Cancel',
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6'
      });

      if (confirmed.isConfirmed) {
        this.loading = true;

        await axios.delete(`/admin/fee-rules/${id}`);

        this.success = `Fee "${name}" was successfully deleted.`;

        this.channels = this.channels.filter(channel => channel.id !== id);
        this.totalRecords--;

        setTimeout(() => this.success = '', 3000);

        this.debounceGetTaxes(this.currentPage, this.perPage, this.selectedCountry, this.type, this.keyword);

        this.loading = false;
      }
    }


  }
}
</script>
